import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { card } from '../CSS/card'
import { font } from '../CSS/font'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActionArea from '@material-ui/core/CardActionArea'

import moment from 'moment'


const styles = {...font,...card}
console.log(styles)

// card template

// need to pass in :
//            header : card title text, string,
//            subheader : card subtitle text, string,
//            content : card content, react component
//            contentText : card content, string
//            cardStyle : card hight
class CustomizedCard extends Component {

    constructor(props) {
        super(props);
    }

    componentWillUpdate(prevProps) {

    }


    render() {
        let { classes } = this.props
        let tableRowIndex = 0
        // have to use switch because classes.XXX is a styling variable which can not be treated as value of a JSON file

        let cardSize = (()=>{
            switch (this.props.cardStyle){
            case 'full':
                return classes.card_full
            case '2_3rd':
                return classes.card_2_3rd     
            case 'long':
                return classes.card_long
            case 'mid':
                return classes.card_mid
            case '1_3rd':
                return classes.card_1_3rd   
            case 'short':
                return classes.card_short
            case 'veryShort':
                return classes.card_very_short
            default:
                return classes.card_fit_content
            }
        })
        const contentText = this.props.contentText == null ? [] : this.props.contentText
        const subheader = this.props.subheader == null ? [] : this.props.subheader
        if (this.props.action == null){
            return (
                <Card className={cardSize()}>
                        {this.props.header == null ? null :
                            <Typography className={classes.card_header}>
                                {this.props.header}
                            </Typography>
                        }
                        {subheader.map((paragraph)=>{
                            return(
                                <Typography className={classes.card_subheader}>
                                    {paragraph}
                                </Typography>
                            )
                        })}
                        {this.props.contentText == null && this.props.content == null? null :
                            <CardContent className={classes.content} style={{overflowY:'auto', height:this.props.contentHeight}}>
                                {contentText.map((paragraph)=>{
                                    return(
                                        <Typography className={classes.card_content_text}>
                                            {paragraph}
                                        </Typography>
                                    )
                                })}
                                {this.props.content}
                            </CardContent>
                        }
                </Card>
            )
        } else {
            return (
                <Card className={cardSize()}>
                    <CardActionArea className={classes.cardAction}>
                        {this.props.header == null ? null :
                            <Typography className={classes.card_header}>
                                {this.props.header}
                            </Typography>
                        }
                        {subheader.map((paragraph)=>{
                            return(
                                <Typography className={classes.card_subheader}>
                                    {paragraph}
                                </Typography>
                            )
                        })}
                        <CardContent className={classes.content} style={{overflowY:'auto', height:this.props.contentHeight}}>
                            {contentText.map((paragraph)=>{
                                return(
                                    <Typography className={classes.card_content_text}>
                                        {paragraph}
                                    </Typography>
                                )
                            })}
                            {this.props.content}
                        </CardContent>
                    </CardActionArea>
                </Card>
            )
        }
    }
}
export default withStyles(styles)(CustomizedCard);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/card.js